import { handleActions } from "redux-actions";

const notificationReducer = handleActions(
  {
    NOTIFICATION: {
      ADD: (state, action) => ({
        notifications: [...state.notifications, action.payload.notification],
      }),
      REMOVE: (state, action) => ({
        notifications: state.notifications.filter((n) => n.id !== action.meta.notificationID),
      }),
    },
  },
  {},
  { namespace: "_" }
);

export default notificationReducer;
